module.exports = __webpack_public_path__ + "img/sign-36.5d67fdf6.jpg";